<template>
  <md-table v-bind="$attrs" v-on="$listeners">
    <slot></slot>

    <md-table-row v-show="value.length">
      <!-- <slot name="first-header"> </slot> -->
      <md-table-cell v-for="header in tableHeaders" :key="header">{{ header }}</md-table-cell>
      <md-table-cell>Acciones</md-table-cell>
    </md-table-row>

    <template v-for="item in value">
      <slot name="md-table-row" :item="item" />
    </template>
  </md-table>
</template>

<script>
export default {
  name: "BaseTable",

  computed: {
    tableAttrs() {
      const { value, ...attrs } = this;
      return attrs;
    },
  },

  props: {
    value: {
      type: Array,
    },
    tableHeaders: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Tables/BaseTable.vue